import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import '../assets/css/components/student-quality-list.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faCircle)

/**
 *  Simple list that displays a list of student names along with their work product quality for
 *  whatever activity this list is associated with.
 *
 *  If qualities are not given, then only the student name will be displayed.
 */

const StudentQualityList = props => {
  const { students, title, text, maxListLength } = props

  // Quality can be represented by numbers 0-3 or a string
  const getQualityClass = {
    incomplete: 'incomplete',
    'great-struggle': 'great-struggle',
    'struggle': 'struggle',
    'no-struggle': 'no-struggle',
    0:  'incomplete',
    1:  'great-struggle',
    2:  'struggle',
    3:  'no-struggle'
  }

  const alphabetizedStudents = _.orderBy(students, student => [student.name.split(' ')[1] ? student.name.split(' ')[1].toUpperCase() : null, student.name.split(' ')[0].toUpperCase() ])


  return(
    <div className='student-quality-list'>
      {title && <div className='title'>{title}</div>}
      {text && <div className='text'>{text}</div>}
      <ul style={{ maxHeight: `${maxListLength*35}px` }} className='list-item-container'>
        {_.map(alphabetizedStudents, student =>
          <li key={student.name} className='list-item'>
            <span className='student-name'>{student.name}</span>
            {!!student.quality &&
              <span className={`quality ${getQualityClass[student.quality]}`}>
                <FontAwesomeIcon icon='circle'/>
              </span>
            }
          </li>
        )}
      </ul>
    </div>
  )
}

StudentQualityList.propTypes = {
  /** List of student names and qualities to display */
  students: PropTypes.arrayOf(
    PropTypes.shape({
        name:     PropTypes.string.isRequired,
        quality:  PropTypes.oneOf([0, 1, 2, 3, 'incomplete', 'great-struggle', 'struggle', 'no-struggle'])
      }),
    ),
  /** Title of the list. This is formatted larger than the text prop */
  title: PropTypes.string,
  /** Text to display at the top of the list in lieu of a title */
  text: PropTypes.string,
  /** How many students can be displayed before the list must be scrolled */
  maxListLength: PropTypes.number.isRequired
}

StudentQualityList.defaultProps = {
  maxListLength: 5
}

export default StudentQualityList
